export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.ttf?1495f578452eb676f730244d3b9368cd";